import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import React from "react";
import { useField } from "react-final-form";

type DatePickerProps = Partial<React.ComponentProps<typeof MUIDatePicker>> & {
  field: string;
  label: string;
  required?: boolean;
  className?: string;
  form?: any;
  clearable?: true;
  id?: string;
};

export const DatePicker: React.FC<DatePickerProps> = ({
  field,
  required = false,
  className,
  form,
  clearable,
  id,
  ...datePickerProps
}) => {
  const f = useField(field);
  const defaultHelperText = required ? null : "Optional";
  const helperText = (f.meta.touched && f.meta.error) || defaultHelperText;
  const error = Boolean(f.meta.touched && f.meta.error);

  return (
    <MUIDatePicker
      slotProps={{
        textField: {
          className: className,
          format: "MM/DD/YYYY",
          helperText: helperText,
          error: error,
          id: id || field,
          ...form,
        },
      }}
      componentsProps={{
        actionBar: {
          actions: clearable ? ["clear"] : [],
        },
      }}
      {...f.input}
      {...datePickerProps}
      value={f.input.value || null}
    />
  );
};
